import Vue from "vue";
import App from "./App";
import ajax from "./utils/ajax";
import utils from "./utils/utils";
import router from "./router";

import VDistpicker from "v-distpicker";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import "@/assets/sass/index.scss";

Vue.config.productionTip = false;

Vue.prototype.$http = ajax;
Vue.prototype.$utils = utils;
Vue.prototype.$moment = window.moment;

import * as filters from "./filters";
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

import plugins from "./plugins";
Vue.use(plugins);

Vue.component("v-distpicker", VDistpicker);
Vue.use(ElementUI);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: {
    App
  },
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js